import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { Skeleton } from "components/ui/Skeleton";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/Table";
import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";

dayjs.locale("ko");

const StyledCard = styled(Card)`
  box-shadow: none;
  padding: 0 16px;
  gap: 0;
  border: none;
`;

const StyledCardHeader = styled(CardHeader)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 12px;
`;

const StyledCardTitle = styled(CardTitle)`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: #333333;
`;

const StyledCardContent = styled(CardContent)`
  padding-left: 0;
  padding-right: 0;
`;

const OverflowWrapper = styled.div`
  overflow-x: auto;
`;

const SkeletonFullWidth = styled(Skeleton)`
  height: 20px;
  width: 100%;
`;

/**
 * 실제 표의 열 수와 맞춰야 로딩 중 폭이 튀지 않는다.
 * 열은 날짜·일일 매출·누적 매출(3) + 단가 2종(양도 수수료·기타 탭에서는 숨김).
 */
const BASE_COLUMN_COUNT = 3;
const UNIT_PRICE_COLUMN_COUNT = 2;

export const SalesDataTableSkeleton = ({
  showUnitPrice = true,
}: {
  showUnitPrice?: boolean;
}) => {
  const { searchParams } = useUpdateUrlParams();
  const referenceMonth = searchParams.get("month") || dayjs().format("YYYY-MM");
  const columnCount =
    BASE_COLUMN_COUNT + (showUnitPrice ? UNIT_PRICE_COLUMN_COUNT : 0);

  return (
    <StyledCard>
      <StyledCardHeader>
        <StyledCardTitle>
          {dayjs(referenceMonth).format("YY년 M월")} 매출 내역
        </StyledCardTitle>
      </StyledCardHeader>
      <StyledCardContent>
        <OverflowWrapper>
          <Table>
            <TableHeader>
              <TableRow>
                {[...Array(columnCount)].map((_, i) => (
                  <TableHead key={i}>
                    <SkeletonFullWidth />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {[...Array(5)].map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {[...Array(columnCount)].map((_, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <SkeletonFullWidth />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </OverflowWrapper>
      </StyledCardContent>
    </StyledCard>
  );
};
